// extracted by mini-css-extract-plugin
export default {"container":"fC-z","dimension":"gC-z","dimensionLabels":"hC-z"};